module.exports = __webpack_public_path__ + "img/3.2928ec1e.png";